import { StoreSurcharges } from "../../../redux_store/store/models";

export interface StoreResponse {
  id: number;
  name: string;
  address1: string;
  address2: string;
  city: string;
  postCode: string;
  state: string;
  longitude: number;
  latitude: number;
  orderLink: string;
  cateringLink: string;
  orderingName: string;
  tradingHours: StoreTradingHour[];
  phone: string;
  fax: string;
  email: string;
  campaignMonitorCode: string;
  primaryMarketingArea: string;
  trafficVolume: string;
  brandSiteRestaurantLink: null;
  additionalDetails: string;
  storeGroup: string;
  longDescription: string;
  disableStoreOrder: boolean;
  formattedStoreName: string;
  orderOffset: OrderOffset[];
  tags: null | { tag: string }[];
  minOrderValue: number;
  maxOrderValue: number;
  isGstIncluded: boolean;
  timeZoneInfo: StoresTimeZone;
  deliveryPartners: DeliveryPartners;
  surcharges: StoreSurcharges[];
}

export interface StoresTimeZone {
  storeName: string;
  storeTimeZone: string;
  storeUtc: string;
  storeTimeDate: string;
}

export interface DeliveryPartners {
  availablePartners: { name: string; link: string }[];
  unavailableMessage: string;
}

export interface OrderOffset {
  value: number;
  offset: number;
}

export enum StateAU {
  ACT = "ACT",
  NT = "NT",
  NSW = "NSW",
  QLD = "QLD",
  SA = "SA",
  VIC = "VIC",
  WA = "WA",
}

export enum StateUS {}

export enum StoreDays {
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
  Sunday = "Sunday",
}

export interface MenuHours {
  sections: MenuTradingHour[];
}

export interface MenuTradingHour {
  id: number;
  tradingHours: TradingHour[];
}

export interface TradingHour {
  enabled: boolean;
  timePeriods: TimePeriod[];
  dayOfWeek: string;
}

export interface TimePeriod {
  endTime: string;
  openTime: string;
}

export interface StoreTradingHour {
  dayOfWeek: StoreDays;
  timePeriods: TimePeriod[];
  date?: string;
}

export interface GooglePlaceResponse {
  predictions: Prediction[];
  status: string;
}

export interface Prediction {
  description: string;
  distance_meters?: number;
  matched_substrings: MatchedSubstring[];
  place_id: string;
  reference: string;
  structured_formatting: StructuredFormatting;
  terms: Term[];
  types: string[];
}

export interface MatchedSubstring {
  length: number;
  offset: number;
}

export interface StructuredFormatting {
  main_text: string;
  main_text_matched_substrings: MatchedSubstring[];
  secondary_text: string;
}

export interface Term {
  offset: number;
  value: string;
}

export interface GooglePlaceDetailResponse {
  html_attributions: any[];
  result: Result;
  status: string;
}

export interface Result {
  geometry: Geometry;
}

export interface Geometry {
  location: Location;
  viewport: Viewport;
}

export interface Location {
  lat: number;
  lng: number;
}

export interface Viewport {
  northeast: Location;
  southwest: Location;
}

export interface OrderTimeSlotsResponse {
  timeZoneInfo: StoresTimeZone;
  orderTimes: OrderTime[];
  orderOffset: OrderOffset[];
}

export interface OrderTime {
  date: string;
  day: number;
  timeSlots: string[];
}
